import { Component, OnDestroy } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { LayoutService } from '../layout.service';
import { BreadcrumbItem } from '../modeles/breadcrumb-item';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnDestroy {
  subscription: Subscription;
  private subscriptionRemover = new Subject<void>();

  public locale!: string;
  items: BreadcrumbItem[] = [];
  // Only display items that link to accessible pages,
  // plus always keep the last (current) item
  get displayItems(): BreadcrumbItem[] {
    const arr = this.items || [];
    const lastIndex = arr.length - 1;
    // Keep only items that link to a real page (routerLink defined and not home '/')
    // Always keep the last item (current page), even without routerLink
    return arr.filter((item, index) => {
      if (index === lastIndex) return true;
      if (item.routerLink === undefined) return false;
      if (item.routerLink === '/') return false; // avoid duplicate 'Accueil' next to home icon
      return true;
    });
  }

  home: BreadcrumbItem;

  constructor(
    public breadcrumbService: BreadcrumbService,
    private translate: TranslateService,
    private layout: LayoutService
  ) {
    this.locale = this.translate.currentLang;

    this.translate.onLangChange
      .pipe(takeUntil(this.subscriptionRemover))
      .subscribe(
        (langChangeEvent: LangChangeEvent) =>
          (this.locale = langChangeEvent.lang)
      );

    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
    });

    this.home = { icon: 'home', routerLink: '/' };
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  navigateToAccueil() {
    this.layout.setSelectedMenu('home');
  }
}
